import * as React from "react";
import { cn } from "../lib/cn";

export interface LogoMarkProps extends React.ComponentProps<"svg"> {
  size?: number;
}

/**
 * Atrix Analytics glyph: three rising bars under a trend stroke that exits
 * as a 45° beam — the Atrix Mail "beam" gesture, applied to a chart.
 */
export function LogoMark({ size = 24, className, ...props }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path d="M4 20v-4M10 20v-7M16 20v-4" stroke="var(--accent-core)" strokeWidth="2.2" strokeLinecap="round" />
      <path
        d="M4 11.5 L10 8 L14.5 10.5 L21 3.5"
        stroke="var(--accent-core)"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export interface LogoWordmarkProps extends React.ComponentProps<"span"> {
  markSize?: number;
}

/** "atrix" lowercase + a small ANALYTICS tab. Font inherits from context. */
export function LogoWordmark({ markSize = 20, className, ...props }: LogoWordmarkProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)} {...props}>
      <LogoMark size={markSize} />
      <span className="font-display text-[17px] leading-none font-semibold tracking-tight text-fg">atrix</span>
      <span className="rounded-sm bg-accent-soft px-1 py-0.5 font-mono text-[9px] leading-none font-semibold tracking-[0.14em] text-accent">
        ANALYTICS
      </span>
    </span>
  );
}
